import clsx from 'clsx';
import React from 'react';

import Byline from '@components/Byline';
import { Author } from '@interfaces/authors';

import ArticleHeader from './ArticleHeader';
import ArticleImage from './ArticleImage';
import ArticleWrapper from './ArticleWrapper';
import Highlight from './Highlight';

export type ArticleFeedItemProps = {
  authors: Author[];
  commentsCount: number;
  contentIndex?: number;
  highlight?: string;
  id: number;
  isPro?: boolean;
  newsletterSlug?: string;
  picture: string | null;
  publishedAt?: string;
  skipPictureOptimization?: boolean;
  slug: string;
  title?: string;
  wrapperClassName?: string;
};

const ArticleFeedItem = ({
  authors,
  commentsCount,
  contentIndex,
  highlight,
  id,
  isPro,
  newsletterSlug,
  picture,
  publishedAt,
  skipPictureOptimization,
  slug,
  title,
  wrapperClassName,
}: ArticleFeedItemProps) => {
  return (
    <ArticleWrapper
      articleAuthors={authors}
      articleId={id}
      contentIndex={contentIndex}
      className={clsx(
        'flex-col border-0 border-b border-solid border-grayscale-gray px-16 py-32 sm:flex-row sm:px-0 sm:py-48',
        wrapperClassName
      )}
    >
      <ArticleImage
        className={clsx({
          'sm:h-[calc(213px*9/16)] sm:w-[213px] lg:h-[calc(302px*9/16)] lg:w-[302px]':
            newsletterSlug,
          'sm:h-[calc(302px*9/16)] sm:w-[302px] lg:h-[calc(416px*9/16)] lg:w-[416px]':
            !newsletterSlug,
        })}
        id={id}
        isPro={isPro}
        isMobileFullWidth
        picture={picture}
        skipOptimization={skipPictureOptimization}
        sizes="(min-width: 1200px) 500px, (min-width: 768px) 300px, (min-width: 480px) 600px, 400px"
        slug={slug}
        title={title}
        newsletterSlug={newsletterSlug}
      />
      <div className="ml-0 mt-16 sm:ml-24 sm:mt-0">
        {highlight && <Highlight highlight={highlight} />}
        <ArticleHeader
          className="text-headline-xs lg:text-headline-sm"
          data-testid="article-title"
          title={title}
          slug={slug}
          newsletterSlug={newsletterSlug}
        />
        <Byline
          authors={authors}
          commentsCount={commentsCount}
          publishedAt={publishedAt}
          newsletterSlug={newsletterSlug}
          slug={slug}
        />
      </div>
    </ArticleWrapper>
  );
};

export default ArticleFeedItem;
